import React, { useEffect, useState } from 'react'
import classes from "./FantasyGame2.module.css"
import { useLocation, useNavigate } from 'react-router-dom'
import { fantasyGameLeaderboardApi, matchDetailsApi, userFantasyTeamApi } from '../../http/http';
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment-timezone";
import { FaArrowLeft, FaCircle, FaMinus } from 'react-icons/fa6';
import MyTeam2 from '../../component/NewComponents/MyTeam2';
import MatchEvents2 from '../../component/NewComponents/MatchEvents2';
import { toast } from 'react-toastify';
import SmallLoader from '../../component/SmallLoader';
import { removeUserDetails } from '../../store/slices/userSlice';
import PlayerPointsModal2 from '../../component/NewComponents/PlayerPointsModal2';
import { useTranslation } from 'react-i18next';

const FantasyGame2 = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [matchDetails, setMatchDetails] = useState(null);
    const [matchDetails2, setMatchDetails2] = useState(null);
    const [team, setTeam] = useState(null);
    const [tab, setTab] = useState("myteam");

        const { t } = useTranslation();
    

    const [leaderboard, setLeaderboard] = useState([]);
    const [userRank, setUserRank] = useState(null);

    const { userDetails } = useSelector(state => state?.persisted?.userSlice);
    const { playerPointsModal, playerId, matchFixtureId } = useSelector(state => state?.playerPointsModalSlice);

    const [time, setTime] = useState(null);
    const [display, setDisplay] = useState("block");

    const [loading, setLoading] = useState(true);
    const [loader, setLoader] = useState(true);
    const [leaderboardLoading, setLeaderboardLoading] = useState(true);
    const [userTeamLoading, setUserTeamLoading] = useState(true);

    const dispatch = useDispatch();

    const fetchMatchDetails = async (load) => {
        try {
            if (load) setLoading(true);
            setLoader(true);
            const response = await matchDetailsApi(location?.state?.match_fixture_id, userDetails?.token);
            setMatchDetails(response?.data);
            if (response?.data?.match_details) {
                setMatchDetails2(JSON.parse(response?.data?.match_details));
            }
            setLoading(false);
            setLoader(false);
        } catch (error) {
            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("48"));
                navigate('/');
            } else {
                setLoading(false);
                setLoader(false);
                toast.error(t("20"));
            }
        }
    }

    const fetchUserTeam = async (load) => {
        try {
            if (load) setUserTeamLoading(true);
            setLoader(true);
            const response = await userFantasyTeamApi(location?.state?.match_fixture_id, userDetails?.token);
            setTeam(JSON.parse(response?.data?.team));
            setLoader(false);
            setUserTeamLoading(false);
        } catch (error) {
            setLoader(false);
            setUserTeamLoading(false);
            toast.error(t("20"));
        }
    }

    const fetchMatchLeaderboard = async (load) => {
        try {
            if (load) setLeaderboardLoading(true);
            setLoader(true);
            const response = await fantasyGameLeaderboardApi(location?.state?.match_fixture_id, userDetails?.token);
            setLeaderboard(response?.data?.leaderboard);
            setUserRank(response?.data?.userRank?.[0]);
            setLeaderboardLoading(false);
            setLoader(false);
        } catch (error) {
            setLeaderboardLoading(false);
            setLoader(false);
            toast.error(t("20"));
        }
    }

    useEffect(() => {
        if (location?.state?.match_fixture_id) {
            fetchMatchDetails(true);
            fetchUserTeam(true);
            fetchMatchLeaderboard(true);
        } else {
            navigate("/home");
        }
    }, [location?.state?.match_fixture_id]);

    const matchTimer = (match_date_time) => {
        try {
            const liveTime = moment();
            const matchTime = moment.utc(match_date_time);
            const timeLeft = moment.duration(matchTime.diff(liveTime));
            if (timeLeft.asMilliseconds() <= 0) {
                setDisplay("none");
            }
            const hours = Math.floor(timeLeft.asHours());
            const minutes = timeLeft.minutes();
            const seconds = timeLeft.seconds();
            setTime(`${hours}h ${minutes}m ${seconds}s`);
        } catch (error) {
            console.log(error, 'error--');
        }
    }

    useEffect(() => {
        if (matchDetails?.match_status == "NS" && display != "none") {
            const intervalId = setInterval(() => {
                matchTimer(matchDetails?.match_date_time);
            }, 1000);
            return () => clearInterval(intervalId);
        }
    }, [matchDetails, display]);

    useEffect(() => {
        if (!loader && location?.state?.match_fixture_id) {
            const intervalId = setInterval(() => {
                if (!document.hidden) {
                    fetchMatchDetails();
                    fetchUserTeam();
                    fetchMatchLeaderboard();
                }
            }, 10000);
            return () => clearInterval(intervalId);
        }
    }, [loader, location?.state?.match_fixture_id]);

    const renderStatus = () => {
        const s = matchDetails?.match_status;
        const elapsed = matchDetails2?.fixture?.status?.elapsed;
        const extra = matchDetails2?.fixture?.status?.extra;

        if (["FT", "AET", "PEN"].includes(s)) return <span className={classes.status_text}>{t("87")}</span>;
        if (s === "SUSP") return <span className={classes.status_text}>{t("88")}</span>;
        if (s === "PST")  return <span className={classes.status_text}>{t("89")}</span>;
        if (s === "CANC") return <span className={classes.status_text}>{t("90")}</span>;
        if (["ABD", "AWD", "WO"].includes(s)) return <span className={classes.status_text}>{t("91")}</span>;
        if (s === "HT")   return <span className={classes.status_text}><FaCircle className={`${classes.text_danger_glow} ${classes.blink}`} style={{ fontSize: 8, marginRight: 6 }} />{t("92")} {elapsed}`</span>;
        if (s === "ET")   return <span className={classes.status_text}><FaCircle className={`${classes.text_danger_glow} ${classes.blink}`} style={{ fontSize: 8, marginRight: 6 }} />{elapsed}` ET +{extra}`</span>;
        if (s === "P")    return <span className={classes.status_text}><FaCircle className={`${classes.text_danger_glow} ${classes.blink}`} style={{ fontSize: 8, marginRight: 6 }} />{t("93")} {elapsed}`</span>;
        if (["1H", "2H", "LIVE"].includes(s)) return <span className={classes.status_text}><FaCircle className={`${classes.text_danger_glow} ${classes.blink}`} style={{ fontSize: 8, marginRight: 6 }} />{elapsed}`</span>;
        return null;
    };

    return (
        <div className={classes.page}>
            <div className={classes.pageInner}>

                {/* ── Sticky header ── */}
                <div className={classes.header}>

                    {/* Top nav */}
                    <div className={classes.header_nav}>
                        <div className={classes.header_nav_container}>
                            <button type="button" className={classes.back_button} onClick={() => navigate("/home")}>
                                <FaArrowLeft className={classes.back_icon} />
                            </button>
                        </div>
                    </div>

                    {/* Match details */}
                    {loading ? (
                        <div style={{ padding: "20px", display: "flex", justifyContent: "center", background: "var(--green-deep)" }}>
                            <SmallLoader />
                        </div>
                    ) : (
                        <div className={classes.match_details_container}>
                            {renderStatus() && (
                                <div className={classes.match_status}>
                                    {renderStatus()}
                                </div>
                            )}

                            <div className={classes.match_details}>
                                <div className={classes.team}>
                                    <img src={matchDetails?.home_team_image} alt={matchDetails?.home_team_name} className={classes.team_logo} />
                                    <span className={classes.team_name}>{matchDetails?.home_team_name}</span>
                                </div>
                                <div className={classes.score_container}>
                                    {/* <span className={classes.score}>{matchDetails2?.goals?.home ?? "-"}</span> */}
                                    <span className={classes.score}>{matchDetails2?.goals?.home}</span>
                                    <div className={classes.separator}><FaMinus className={classes.separator_icon} /></div>
                                    {/* <span className={classes.score}>{matchDetails2?.goals?.away ?? "-"}</span> */}
                                    <span className={classes.score}>{matchDetails2?.goals?.away}</span>
                                </div>
                                <div className={classes.team}>
                                    <img src={matchDetails?.away_team_image} alt={matchDetails?.away_team_name} className={classes.team_logo} />
                                    <span className={classes.team_name}>{matchDetails?.away_team_name}</span>
                                </div>
                            </div>

                            {matchDetails?.match_status === "NS" && (
                                <div className={classes.match_timer_container} style={{ display }}>
                                    <span className={classes.match_timer}>⏱ {time}</span>
                                </div>
                            )}

                            <span className={classes.match_time}>
                                {moment.utc(matchDetails?.match_date_time).local().format("dddd, DD MMM YYYY [at] hh:mm A")}
                            </span>
                        </div>
                    )}

                    {/* Tabs */}
                    <div className={classes.tabs_container}>
                        {["myteam", "leaderboard", "events"].map(ta => (
                            <button
                                key={ta}
                                type="button"
                                className={`${classes.tab_option} ${tab === ta ? classes.active : ''}`}
                                onClick={() => setTab(ta)}
                            >
                                {ta === "myteam" ? t("98") : ta === "leaderboard" ? t("99") : t("100")}
                            </button>
                        ))}
                    </div>
                </div>

                {/* ── Tab content ── */}
                <div className={classes.content}>
                    {tab === "myteam" ? (
                        userTeamLoading ? <SmallLoader /> : team && (
                            <>
                                <MyTeam2
                                    attackers={team?.filter(d => d?.position === "Attacker")}
                                    defenders={team?.filter(d => d?.position === "Defender")}
                                    midfielders={team?.filter(d => d?.position === "Midfielder")}
                                    goalkeeper={team?.filter(d => d?.position === "Goalkeeper")}
                                    match_fixture_id={location?.state?.match_fixture_id}
                                />
                                {matchDetails?.match_status === "NS" && (
                                    <div className={classes.edit_button_container}>
                                        <button
                                            type="button"
                                            className={classes.edit_button}
                                            onClick={() => navigate("/create-fantasy-team", {
                                                state: { match_fixture_id: matchDetails?.match_fixture_id, edit: true }
                                            })}
                                        >
                                            {t("94")}
                                        </button>
                                    </div>
                                )}
                            </>
                        )
                    ) : tab === "events" ? (
                        <div className={classes.grid_col_2}>
                            <MatchEvents2
                                team_name={matchDetails?.home_team_name}
                                data={matchDetails2?.events?.filter(d =>
                                    d?.team?.name === matchDetails?.home_team_name &&
                                    d?.type === "Goal" &&
                                    d?.detail !== "Missed Penalty"
                                )}
                            />
                            <MatchEvents2
                                team_name={matchDetails?.away_team_name}
                                data={matchDetails2?.events?.filter(d =>
                                    d?.team?.name === matchDetails?.away_team_name &&
                                    d?.type === "Goal" &&
                                    d?.detail !== "Missed Penalty"
                                )}
                            />
                        </div>
                    ) : tab === "leaderboard" ? (
                        leaderboardLoading ? <SmallLoader /> : (
                            <div className={classes.leaderboard_container}>
                                <div className={classes.headings}>
                                    <div className={classes.rank_heading}>{t("95")}</div>
                                    <div className={classes.number_heading}>{t("96")}</div>
                                    <div className={classes.points_heading}>{t("97")}</div>
                                </div>
                                {leaderboard?.map((data, index) => (
                                    <div className={classes.leaderboard_data} key={index}>
                                        <div className={classes.rank_data}>{data?.rank}</div>
                                        <div className={classes.number_data}>{data?.msisdn}</div>
                                        <div className={classes.points_data}>{data?.total_points}</div>
                                    </div>
                                ))}
                            </div>
                        )
                    ) : null}
                </div>

                <PlayerPointsModal2 matchFixtureId={matchFixtureId} playerId={playerId} playerPointsModal={playerPointsModal} />
            </div>
        </div>
    );
};

export default FantasyGame2;